import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { HttpcallService } from '../../services/httpcall.service';

@Component({
  selector: 'app-xblr-elements',
  templateUrl: './xblr-elements.component.html'
})
export class XBLRElementsComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();

  constructor( private graphQLService: GraphqlService, private route: Router, private commonDataService: CommonDataService, private httpCallService: HttpcallService) {

  }
  outcome: boolean = false;
  pageNums: string = "";
  publicationId: string = "";
  currentPara: string = "";
  parameter: string[] = [];
  pageUrl: string = "";
  xbrlList
  xbrlPageUrl: string = "";
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.pageUrl.subscribe(data => { this.pageUrl = data; this.publicationId = this.pageUrl.split("/")[0]; })
    let url = this.pageUrl;
    this.graphQLService.GetBreadcrumbSession(url).subscribe(data => {
      this.navData = JSON.parse(JSON.stringify(data));
      this.breadcrumbPath = this.navData.crumbData.join(",");
      this.xbrlContent = this.navData.menuData.filter(x => x.menuItem.includes("GAAP Taxonomy Elements"));
      if (this.xbrlContent.length != 0) {
        this.xbrlPageUrl = this.xbrlContent[0].menuUrl;
      }
    });
    this.commonDataService.currentParagraph.subscribe(currentP => { let paraBreak = currentP.split("-"); this.currentPara = paraBreak[2] + "-" + paraBreak[3]; });
    this.commonDataService.XBRLParams.subscribe(params => {
      this.pageNums = params;
      this.parameter = this.pageNums.split("-");
    });
    this.httpCallService.getXBRLParagraph(this.publicationId, this.parameter[0], this.parameter[1], this.currentPara).subscribe((xbrlList: any) => {
      this.xbrlParaData = [];
      this.reference = xbrlList.references;
      this.outcome = true; this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err); this.outcome = true;
      this.commonDataService.showLoader.next(false);
    });
}

   redirectToHelp() {
    this.myEvent.emit();
    this.route.navigateByUrl("/helpxbrlfeature");
  }
  mouseOverFunctions(event: any, elementName) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase().includes("xbrlelement")) {
          event.srcElement.setAttribute("href", this.xbrlPageUrl + "/" + elementName);
    }
  }

  xbrlParaData;
  reference;
  breadcrumbPath: string = "";
groupArrayOfObjects(list, key) {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

  navData = {
    crumbData: [],
    menuData: [],
  }
  xbrlContent
  navigateToXBRLContent(event, elementName: string) {
    event.preventDefault();
    this.commonDataService.pageUrl.subscribe(data => { this.pageUrl = data ; this.publicationId = this.pageUrl.split("/")[0]; })
    let url = this.pageUrl;
    this.graphQLService.GetBreadcrumbSession(url).subscribe(data => {
      this.navData = JSON.parse(JSON.stringify(data));
      this.breadcrumbPath = this.navData.crumbData.join(",");
      this.xbrlContent = this.navData.menuData.filter(x => x.menuItem.includes("GAAP Taxonomy Elements"));
      if (this.xbrlContent.length != 0) {
        localStorage.setItem("xbrlReturnPathText", this.parameter[0] + "-" + this.parameter[1] + "-" + this.currentPara);
        localStorage.setItem("xbrlReturnPathLink", this.route.url);
        localStorage.setItem("xbrlElementName", elementName);
        this.commonDataService.backToXBRLActive.next(true);
        this.route.navigateByUrl(this.xbrlContent[0].menuUrl);
      }
    });
    this.myEvent.emit();
  }
}
